import { useEffect } from 'react';
import { useStatsigClient } from '@statsig/react-bindings';
import unifiedAnalytics from './unifiedAnalytics';

/**
 * Custom hook for using the unified analytics service throughout the application
 * @returns {Object} Unified analytics service instance
 */
export const useUnifiedAnalytics = () => {
  const { client } = useStatsigClient();
  
  useEffect(() => {
    // Initialize analytics service with Statsig client if not already initialized
    if (client && !unifiedAnalytics.initialized) {
      unifiedAnalytics.initialize(client);
    }
  }, [client]);

  return unifiedAnalytics;
};

export default useUnifiedAnalytics;
